import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import checkView from 'vue-check-view'
import VueLazyLoad from 'vue-lazyload'
import VueHtmlToPaper from 'vue-html-to-paper';
import Config from './Config.js'
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'
import VueMeta from 'vue-meta'
import 'es6-promise/auto'
import {
  library
}
from '@fortawesome/fontawesome-svg-core'
import {
  faWarehouse, faStopwatch, faWrench, faGlobe, faPhone, faEnvelope,
  faArrowRight, faChevronDown, faChevronUp, faMapMarkerAlt, faKey,
  faCertificate, faCrosshairs
}
from '@fortawesome/free-solid-svg-icons'
import {
  FontAwesomeIcon
}
from '@fortawesome/vue-fontawesome'

import * as VueGoogleMaps from 'vue2-google-maps'


import {
  store
}
from './store';
import DealerSearch from './components/DealerSearch.vue'
import UserRequestHandler from './components/UserRequestHandler.vue'


import {
  i18n
}
from './plugins/i18n.js'

const MAPS_CONSENT_STORAGE_KEY = 'rewaco-maps-consent-v1'

const hasGoogleMapsConsent = () => {
  try {
    return window.localStorage.getItem(MAPS_CONSENT_STORAGE_KEY) === 'accepted'
  } catch (error) {
    return false
  }
}


const printoptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://filedelivery.rewaco.com/files/apps/storage-vehicles/semantic.min.css',
    'https://api.rewaco.com/icon.min.css',
    'https://filedelivery.rewaco.com/files/apps/trike-search/css/print.css',
    'https://filedelivery.rewaco.com/files/apps/trike-search/main.css'
  ]
}

library.add(faWarehouse)
library.add(faStopwatch)
library.add(faWrench)
library.add(faGlobe)
library.add(faPhone)
library.add(faEnvelope)
library.add(faArrowRight)
library.add(faChevronUp)
library.add(faChevronDown)
library.add(faMapMarkerAlt)
library.add(faKey)
library.add(faCertificate)
library.add(faCrosshairs)

if (hasGoogleMapsConsent()) {
  Vue.use(VueGoogleMaps, {
    load: {
      key: Config.googleapikey,
      libraries: 'places',
      v: '3.26'
    },
    installComponents: true
  })
}
Vue.use(VueRouter)
Vue.use(checkView)
Vue.use(VTooltip)
Vue.use(require('vue-moment'));
Vue.use(VModal)
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})


Vue.filter('uppercase', function(value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})

Vue.filter('currency', function(value) {
  return new Intl.NumberFormat("de-DE", {
    style: 'currency',
    currency: ''
  }).format(value)
})

Vue.filter('power', function(value) {
  return Math.round(value * 1.35962)
})

Vue.component('font-awesome-icon', FontAwesomeIcon)

export const serverBus = new Vue();


const routes = [{
  path: '/',
  component: DealerSearch
}, {
  path: '/l/:opt',
  component: DealerSearch,
  props: true
}, {
  path: '/confirm/:key',
  component: UserRequestHandler,
  props: true
}]


const router = new VueRouter({
  routes
})


new Vue({
  el: '#dealer-search',
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#dealer-search')
